<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.banks.retrieveLoader" transition="fade-transition" type="table" />
      <template v-else>
        <v-col v-if="!list.length" class="text-center py-5">
          <v-icon class="d-block" color="secondary" size="70">mdi-bank</v-icon>
          <span class="d-block subtitle-1">No tienes movimientos en la cuenta</span>
        </v-col>
        <template v-else>
          <v-data-table :headers="headers" :items="list" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(t) => { openTransfer(t) }" style="cursor: pointer">
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" @sort="setSort" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.bank`]="{item}">
              <img :src="require(`@/assets/appAsset-bankingLogo__${item.bank_name}_Min.svg`)" :alt="`${item.bank_name} bank brand`" width="24">
            </template>
            <template v-slot:[`item.description`]="{item}">
              <span>{{item.description}}</span>
            </template>
            <template v-slot:[`item.status`]="{item}">
              <v-row align="center" justify="end">
                <v-tooltip v-if="item.auto_match" color="primary" dark max-width="280" right transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" class="mr-2" color="yellow darken-3">mdi-flash</v-icon>
                  </template>
                  <span class="white--text">Esta conciliación se realizó de forma automática.</span>
                </v-tooltip>
                <div class="text-right">
                  <v-chip v-if="item.status === 'finalized'" color="lightBlue" text-color="primary" small>Conciliado<v-icon right x-small>mdi-check</v-icon></v-chip>
                  <v-chip v-else-if="item.status === 'incomplete'" color="defaultGrey" text-color="secondary" small>Incompleto<v-icon right x-small>mdi-clock</v-icon></v-chip>
                  <v-chip v-else-if="item.status === 'archived'" color="defaultGrey" text-color="secondary" small>Archivado</v-chip>
                  <v-chip v-else-if="item.status === 'pending'" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
                </div>
              </v-row>
            </template>
            <template v-slot:[`item.date`]="{item}">
              <span>{{item.date | date}}</span>
            </template>
            <template v-slot:[`item.balance`]="{item}">
              <span class="body-2 text--secondary font-weight-medium">{{item.balance | currency(item.currency)}}</span> <span>{{item.currency}}</span>
            </template>
            <template v-slot:[`item.amount`]="{item}">
              <span class="body-2 text--secondary font-weight-medium">{{item.amount | currency(item.currency)}}</span> <span>{{item.currency}}</span>
            </template>
          </v-data-table>
          <template v-if="showPagination || showAll">
            <v-divider />
            <v-row class="mx-0" align="center">
              <template v-if="showPagination">
                <v-col cols="6">
                  <span class="body-2 text--secondary">{{count}} registros</span>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                </v-col>
              </template>
            </v-row>
          </template>
        </template>
      </template>
    </v-col>

    <!-- dialog transfer -->
    <v-dialog v-model="dialogTransfer" fullscreen no-click-animation persistent scrollable hide-overlay>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Transferencia</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="dialogTransfer=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 overflow-y-auto" style="height: calc(100vh)">
          <v-row class="fill-height" align="start" no-gutters>
            <v-col class="fill-height overflow-y-auto">
              <!-- summary -->
              <v-row class="mx-0 white" align="center">
                <img class="mx-4 mt-1" v-if="selectedTransfer.bank_name" :alt="`${selectedTransfer.bank_name} bank brand`" :src="require(`@/assets/appAsset-bankingLogo__${selectedTransfer.bank_name}_Min.svg`)" width="32">
                <v-col cols="3">
                  <span class="d-block mb-1">Monto</span>
                  <span class="body-1 font-weight-medium mr-1">{{selectedTransfer.amount | currency(selectedTransfer.currency)}} {{selectedTransfer.currency}}</span>
                </v-col>
                <v-divider class="my-2" vertical />
                <v-col cols="3">
                  <span class="d-block mb-1">Por conciliar</span>
                  <span class="body-1 font-weight-medium mr-1">{{selectedTransfer.balance | currency(selectedTransfer.currency)}} {{selectedTransfer.currency}}</span>
                </v-col>
                <v-divider class="my-2" vertical />
                <v-col>
                  <span class="d-block mb-1">Fecha</span>
                  <span class="body-1 font-weight-medium mr-1">{{selectedTransfer.date | date}}</span>
                </v-col>

                <template v-if="selectedTransfer.status === 'archived'">
                  <v-divider class="my-2" vertical />
                  <v-col>
                    <span class="d-block mb-1">Estado</span>
                    <v-chip color="defaultGrey" text-color="secondary" small>Archivado</v-chip>
                  </v-col>
                </template>
              </v-row>
              <v-divider />
              <!-- end summary -->

              <!-- transfer information -->
              <v-list class="v-list-form py-2 transparent">
                <v-list-item>
                  <v-list-item-title class="py-3 text--secondary subtitle-1 font-weight-medium">Información de la transferencia</v-list-item-title>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-title>Nombre del titular</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="selectedTransfer.origin_holder_name">
                      {{selectedTransfer.origin_holder_name}}
                    </template>
                    <template v-else>
                      <span class="font-italic text--disabled">No especificado</span>
                    </template>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-title>ID Fiscal del titular</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="selectedTransfer.origin_holder_id">
                      {{selectedTransfer.origin_holder_id}}
                    </template>
                    <template v-else>
                      <span class="font-italic text--disabled">No especificado</span>
                    </template>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-title>Descripción</v-list-item-title>
                  <v-list-item-subtitle>{{selectedTransfer.description}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-title>ID Banco</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="selectedTransfer.origin_number">
                      {{selectedTransfer.origin_number}}
                    </template>
                    <template v-else>
                      <span class="font-italic text--disabled">No especificado</span>
                    </template>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-title>Fecha del movimiento</v-list-item-title>
                  <v-list-item-subtitle v-if="selectedTransfer.transaction_date">{{selectedTransfer.transaction_date | dateTime}}</v-list-item-subtitle>
                  <v-list-item-subtitle v-else>{{selectedTransfer.date | date}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
              <!-- end transfer information -->

              <template v-if="selectedTransfer.status === 'pending'">
                <v-divider class="my-6" />

                <v-list class="mx-4" two-line>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Ajustar</v-list-item-title>
                      <v-list-item-subtitle class="text--primary">Realiza cambios específicos en el monto de la transferencia.</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action v-if="!adjustments.length">
                      <v-btn @click="dialogAdjustment = true" color="secondary" outlined retain-focus-on-click :ripple="false">Crear ajuste</v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <template v-if="adjustments.length">
                  <v-sheet v-for="a in adjustments" class="mx-4 mb-3 px-4 py-1" :key="`${a.id}-adjustment`" outlined rounded>
                    <v-row align="center" justify="space-between">
                      <v-col>
                        <span class="d-block mb-1">Operación</span>
                        <span class="body-1 text--secondary font-weight-medium">
                          <template v-if="a.operation === 'add'">Ajuste positivo</template>
                          <template v-else-if="a.operation === 'sub'">Ajuste negativo</template>
                          <template v-else-if="a.operation === 'exchange'">Conversión</template>
                        </span>
                      </v-col>
                      <v-col>
                        <span class="d-block mb-1">Monto incial</span>
                        <span class="body-1 text--secondary font-weight-medium">{{a.base_amount | currency(a.base_currency)}} {{a.base_currency}}</span>
                      </v-col>
                      <v-col>
                        <span class="d-block mb-1">Monto ajustado</span>
                        <span class="body-1 text--secondary font-weight-medium">
                          <template v-if="a.operation === 'add'">{{(a.amount + a.base_amount) | currency(a.currency)}} {{a.currency}}</template>
                          <template v-else-if="a.operation === 'sub'">{{(a.base_amount - a.amount) | currency(a.currency)}} {{a.currency}}</template>
                          <template v-else-if="a.operation === 'exchange'">{{a.amount | currency(a.currency)}} {{a.currency}}</template>
                        </span>
                      </v-col>
                      <v-col cols="2" class="text-right">
                        <v-tooltip color="red" dark max-width="280" nudge-left="45" transition="scale-transition" top>
                          <template v-slot:activator="{on}">
                            <v-btn v-on="on" @click="destroyAdjustment(a)" class="mr-3" color="red" icon retain-focus-on-click outlined :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                          </template>
                          <span class="white--text">Eliminar ajuste</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-list two-line>
                      <v-list-item class="px-0">
                        <v-list-item-avatar size="36"><v-icon class="secondary lighten-1" dark>mdi-account</v-icon></v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title><span class="text--secondary">{{a.user}}</span> <span class="caption">el {{a.created | dateTime}}</span></v-list-item-title>
                          <v-list-item-subtitle class="text--primary">{{a.comment}}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-sheet>
                </template>

                <v-divider class="mx-4" />

                <v-list class="mx-4" two-line>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Archivar</v-list-item-title>
                      <v-list-item-subtitle class="text--primary">Mueve esta transferencia a un estado inactivo sin eliminarla.</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn @click="destroy(selectedTransfer)" color="red darken-2" dark outlined retain-focus-on-click>Archivar</v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </template>
            </v-col>

            <v-divider v-if="selectedTransfer.status !== 'archived'" vertical />

            <v-col cols="5" v-if="selectedTransfer.status !== 'archived'" class="background fill-height overflow-y-auto">
              <v-row class="mx-0" align="center" style="min-height:74px;">
                <v-col cols="6">
                  <span class="d-block mb-1">Estado de la conciliación</span>
                  <v-chip v-if="selectedTransfer.status === 'pending'" color="defaultGrey" text-color="secondary" small>Pendiente</v-chip>
                  <v-chip v-else-if="selectedTransfer.status === 'archived'" color="defaultGrey" text-color="secondary" small>Archivado</v-chip>
                  <v-chip v-else-if="selectedTransfer.status === 'finalized'" color="lightBlue" text-color="primary" small>Conciliado<v-icon right x-small>mdi-check</v-icon></v-chip>
                  <v-chip v-else-if="selectedTransfer.status === 'incomplete'" color="defaultGrey" text-color="secondary" small>Incompleto<v-icon right x-small>mdi-clock</v-icon></v-chip>
                </v-col>
              </v-row>

              <v-divider />

              <!-- loader -->
              <v-skeleton-loader v-if="$store.state.invoices.retrieveLoader" class="ma-3" transition="fade-transition" type="list-item-avatar-three-line" />
              <!-- end loader -->

              <template v-else>
                <!-- reconciliated invoices -->
                <v-hover  v-for="d in relatedInvoices" v-slot="{ hover }" :key="d.id">
                  <v-card class="ma-3 py-0" :elevation="(hover ? 4 : 2)" :ripple="false" :to="{name: 'PaymentRetrieve', params: {id: d.payments[0].id}}">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <span class="d-block text--secondary font-weight-medium">{{d.document.id | invoiceTypeName(true)}}</span>
                          <span class="d-block text--primary">N° {{d.number}} del {{d.date | date}}</span>

                          <span class="d-block mt-3 text--secondary font-weight-medium">{{d.customer.name}}</span>
                          <span class="d-block caption text--primary">{{d.customer.tax_id}}</span>

                          <span class="d-block mt-3 text--secondary font-weight-medium">{{d.total | currency(d.currency)}} {{d.currency}}</span>
                        </v-list-item-content>

                        <v-list-item-content class="flex-shrink-0">
                          <v-btn :to="{name: 'PaymentRetrieve', params: {id: d.payments[0].id}}" color="primary" max-height="28" max-width="20" min-height="28" min-width="20" :ripple="false" text><v-icon size="20">mdi-open-in-new</v-icon></v-btn>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-hover>
                <!-- end reconciliated invoices -->

                <v-col v-if="['pending', 'incomplete'].includes(selectedTransfer.status)" class="text-center py-5">
                  <v-icon class="my-2" color="secondary" size="48">mdi-connection</v-icon>
                  <span class="d-block body-2 text--primary">
                    <template v-if="selectedTransfer.status === 'pending'">Esta transferencia se encuentra pendiente de conciliación</template>
                    <template v-else-if="selectedTransfer.status === 'incomplete'">Esta transferencia se encuentra parcialmente conciliada</template>
                  </span>
                  <v-btn class="mt-4" @click.stop="openDrawerReconciliation" color="primary" :ripple="false">Conciliar transferencia</v-btn>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- drawer reconciliation -->
      <v-navigation-drawer class="elevation-3" v-model="drawerReconciliation" fixed right persistent width="800">
        <v-card>
          <v-toolbar flat height="55">
            <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Conciliar transferencia</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn @click="closeDrawerReconciliation" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0 overflow-y-auto" style="height: calc(100vh - 56px)">
            <v-row class="fill-height" align="start" no-gutters>
              <v-col cols="6" v-if="selectedTransfer.status !== 'archived'" class="background fill-height overflow-y-auto">
                <!-- search bar -->
                <v-row class="mx-0">
                  <v-col cols="12">
                    <v-text-field v-model="invoiceQuery" background-color="white" outlined required single-line dense maxlength="60" prefix="Buscar" hide-details placeholder="Escribe un número de factura..." />
                  </v-col>
                </v-row>
                <!-- end search bar -->

                <v-toolbar class="transparent" flat height="55">
                  <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
                    <template v-if="invoiceQuery">Resultados</template>
                    <template v-else>Recomendaciones</template>
                  </v-toolbar-title>
                </v-toolbar>

                <v-skeleton-loader v-if="$store.state.invoices.retrieveLoader" class="px-3 mt-3" transition="fade-transition" type="table" />

                <template v-else>
                  <!-- sugestions and search results -->
                  <template v-if="suggestedInvoices.length">
                    <v-hover v-for="d in suggestedInvoices" v-slot="{ hover }" :key="d.id">
                      <v-card @click="toggleInvoiceSelection(d)" class="ma-3 mt-0 py-0" :class="{ 'cursor-not-allowed': disableSelection(d) }" :elevation="(hover && !disableSelection(d) ? 4 : 2)" :ripple="false">
                        <v-list>
                          <v-list-item>
                            <v-list-item-content class="flex-shrink-0">
                              <v-checkbox hide-details :input-value="isInvoiceSelected(d)" :disabled="disableSelection(d)" />
                            </v-list-item-content>

                            <v-list-item-content>
                              <span class="d-block text--secondary font-weight-medium">{{d.document.id | invoiceTypeName(true)}}</span>
                              <span class="d-block text--primary">N° {{d.number}} del {{d.date | date}}</span>

                              <span class="d-block mt-3 text--secondary font-weight-medium">{{d.customer.name}}</span>
                              <span class="d-block caption text--primary">{{d.customer.tax_id}}</span>

                              <span class="d-block mt-3 text--secondary font-weight-medium">{{d.total | currency(d.currency)}} {{d.currency}}</span>
                              <span class="d-block mt-1 orange--text darken-4 font-weight-medium">{{d.payments[0].balance | currency(d.currency)}} {{d.currency}} pendientes de pago</span>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-hover>
                  </template>
                  <!-- end sugestions and search results -->

                  <v-col class="text-center py-5" v-else>
                    <v-icon class="my-2" color="secondary" size="48">mdi-database-remove</v-icon>
                    <span class="d-block px-6 body-2 text--primary">No existen recomendaciones, usa el buscador para encontrar registros</span>
                  </v-col>
                </template>
              </v-col>

              <v-divider v-if="selectedTransfer.status !== 'archived'" vertical />

              <v-col class="fill-height overflow-y-auto">
                <!-- reconciliation summary -->
                <v-list class="pa-3 transparent">
                  <v-list-item class="py-0">
                    <v-list-item-title class="text--primary">Monto por conciliar</v-list-item-title>
                    <v-list-item-subtitle class="text-right text--secondary font-weight-medium">{{ selectedTransfer.balance | currency(selectedTransfer.currency) }} {{ selectedTransfer.currency }}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item class="py-0">
                    <v-list-item-title class="text--primary">Monto a conciliar</v-list-item-title>
                    <v-list-item-subtitle class="text-right text--secondary font-weight-medium" :class="{ 'red--text text--darken-1': (totalReconciliated > selectedTransfer.balance) }">{{ totalReconciliated | currency(selectedTransfer.currency) }} {{ selectedTransfer.currency }}</v-list-item-subtitle>
                  </v-list-item>
                  <v-divider class="my-1" />
                  <v-list-item class="py-0">
                    <v-list-item-title class="text--primary">Pendiente a conciliar</v-list-item-title>
                    <v-list-item-subtitle class="text-right text--secondary font-weight-medium" :class="{ 'red--text text--darken-1': (totalReconciliated > selectedTransfer.balance) }">{{ (selectedTransfer.balance - totalReconciliated) | currency(selectedTransfer.currency) }} {{ selectedTransfer.currency }}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
                <!-- end reconciliation summary -->

                <div class="mx-3 mb-5">
                  <v-btn v-if="totalReconciliated > 0" @click="reconciliateInvoices" block color="primary" :disabled="(totalReconciliated > selectedTransfer.balance)" :ripple="false">Realizar conciliación</v-btn>
                </div>

                <v-card v-for="(d, i) in selectedInvoices" :key="d.id" class="ma-3 py-0" outlined :ripple="false">
                  <v-list>
                    <v-list-item>
                      <v-list-item-content class="ml-3">
                        <span class="d-block text--secondary font-weight-medium">{{d.document.id | invoiceTypeName(true)}}</span>
                        <span class="d-block text--primary">N° {{d.number}} del {{d.date | date}}</span>

                        <span class="d-block mt-3 text--secondary font-weight-medium">{{d.customer.name}}</span>
                        <span class="d-block caption text--primary">{{d.customer.tax_id}}</span>

                        <span class="d-block mt-3 text--secondary font-weight-medium">{{d.total | currency(d.currency)}} {{d.currency}}</span>
                        <span class="d-block mt-1 orange--text darken-4 font-weight-medium text-decoration-line-through">{{d.payments[0].balance | currency(d.currency)}} {{d.currency}} pendientes de pago</span>

                        <template v-if="(totalReconciliated < d.payments[0].balance) || ((i === selectedInvoices.length - 1 && (balanceSelectedInvoices - totalReconciliated) > 0))">
                          <span class="mt-2 orange--text darken-4 text-decoration-underline">Quedará un saldo pendiente de {{(balanceSelectedInvoices - totalReconciliated) | currency(d.currency)}} {{d.currency}}</span>
                        </template>
                      </v-list-item-content>

                      <v-list-item-content class="flex-shrink-0">
                        <v-btn @click="toggleInvoiceSelection(d)" color="red" max-height="28" max-width="20" min-height="28" min-width="20" :ripple="false" text><v-icon size="20">mdi-delete</v-icon></v-btn>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-dialog v-model="dialogAdjustment" width="500" persistent>
          <v-card>
            <v-toolbar flat height="55">
              <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Crear ajuste</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn @click="dialogAdjustment=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider />
            <v-card-text class="pa-0">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Operación</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="7" class="pa-0">
                        <v-select v-model="$v.adjustment.operation.$model" :error="$v.adjustment.operation.$error" :items="adjustmentOperations" item-text="name" item-value="id" outlined background-color="white" dense hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Monto</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="4" class="pa-0">
                        <v-text-field v-model.number="$v.adjustment.amount.$model" :error="$v.adjustment.amount.$error" maxlength="256" background-color="white" outlined required single-line dense hide-details />
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="adjustment.operation === 'exchange'">
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Moneda</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-col cols="7" class="pa-0">
                        <v-select v-model="$v.adjustment.currency.$model" :error="$v.adjustment.currency.$error" :items="currencies.filter(c => !c.conversion)" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                          <template v-slot:item="data">
                            <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                          </template>
                        </v-select>
                      </v-col>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Comentario</v-list-item-title>
                    <v-list-item-subtitle class="ml-1 body-2 text--primary font-weight-regular no-ellipsis">Este comentario ayudará a tu equipo a entender la razón del ajuste</v-list-item-subtitle>
                    <v-list-item-subtitle>
                      <v-text-field v-model="$v.adjustment.comment.$model" :error="$v.adjustment.comment.$error" maxlength="256" background-color="white" outlined required single-line dense hide-details />
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <template v-if="adjustment.operation && adjustment.amount">
                  <v-divider class="my-3" />

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="ml-1 text--secondary subtitle-2 font-weight-medium">Resumen</v-list-item-title>
                      <v-list-item-subtitle class="px-1 py-3 subtitle-1 font-weight-medium">
                        {{selectedTransfer.amount | currency(selectedTransfer.currency) }} {{ selectedTransfer.currency}}
                        <v-icon class="mt-n1 mx-6" color="primary">mdi-arrow-right</v-icon>
                        <template v-if="adjustment.operation === 'add'">{{(selectedTransfer.amount + adjustment.amount) | currency(selectedTransfer.currency)}} {{selectedTransfer.currency}}</template>
                        <template v-else-if="adjustment.operation === 'sub'">{{(selectedTransfer.amount - adjustment.amount) | currency(selectedTransfer.currency)}} {{selectedTransfer.currency}}</template>
                        <template v-else-if="adjustment.operation === 'exchange'">{{adjustment.amount | currency(adjustment.currency)}} {{adjustment.currency}}</template>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
            <v-divider />
            <v-card-actions class="pa-4">
              <v-spacer />
              <v-btn @click="dialogAdjustment=false" outlined>Cancelar</v-btn>
              <v-btn @click="createAdjustment" :loading="loaderAdjustment" color="primary">Crear</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-navigation-drawer>
      <!-- end drawer reconciliation -->
    </v-dialog>
    <!-- end dialog transfer -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { decimal, maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    adjustment: {
      operation: '',
      amount: null,
      currency: '',
      comment: ''
    },
    adjustmentOperations: [
      { id: 'add', name: 'Ajuste positivo' },
      { id: 'sub', name: 'Ajuste negativo' },
      { id: 'exchange', name: 'Conversión' }
    ],
    dialogAdjustment: false,
    dialogTransfer: false,
    drawerReconciliation: false,
    headers: [
      { value: 'bank', width: 60 },
      { text: 'Descripción', value: 'description' },
      { value: 'status', width: 160 },
      { text: 'Fecha', value: 'date', width: 160, align: 'end', sortable: true },
      { text: 'Por conciliar', value: 'balance', width: 160, align: 'end', sortable: true },
      { text: 'Monto', value: 'amount', width: 160, align: 'end', sortable: true }
    ],
    invoiceQuery: '',
    loaderAdjustment: false,
    relatedInvoices: [],
    selectedTransfer: {},
    selectedInvoice: null,
    selectedInvoices: [],
    suggestedInvoices: []
  }),
  computed: {
    ...mapState({
      adjustments: state => state.banks.adjustmentsList,
      count: state => state.banks.ach_transfersCount,
      list: state => state.banks.ach_transfersList
    }),
    balanceSelectedInvoices () {
      /**
       * Calculates the total balance from the selected invoices.
       *
       * @returns {number} The total balance from the selected invoices.
       */
      return this.selectedInvoices.reduce((a, b) => a + b.payments[0].balance, 0)
    },
    totalReconciliated () {
      /**
       * Calculates the total reconciliated amount from the selected invoices.
       * If the total reconciliated amount exceeds the selected transfer balance,
       * it returns the selected transfer balance instead, considering it as a partial payment.
       *
       * @returns {number} The total reconciliated amount or the selected transfer balance, whichever is smaller.
       */
      const totalReconciliated = this.selectedInvoices.reduce((a, b) => a + b.payments[0].balance, 0)

      if (totalReconciliated > this.selectedTransfer.balance) {
        return this.selectedTransfer.balance
      }

      return totalReconciliated
    }
  },
  watch: {
    invoiceQuery () {
      this.debounceMethod(this.getInvoicesFromQuery)
    }
  },
  methods: {
    async reconciliateInvoice (invoice, amount) {
      /**
       * Reconciliate an invoice with the selected transfer
       * create a source and authorize the payment
       * @param {Object} invoice Invoice object
       */
      let source = null

      // set the first payment asociated with the invoice
      const payment = invoice.payments[0]

      // create a source
      try {
        const sourceRequest = await this.$store.dispatch('payments/CREATE', {
          resource: 'sources',
          payload: {
            ach_transfer: this.selectedTransfer.id,
            amount: amount,
            gateway: 'ach_transfer',
            usage: 'single'
          }
        })

        source = sourceRequest.data
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      }

      // authorize the payment
      try {
        await this.$store.dispatch('payments/CREATE', {
          resource: 'payments',
          detail: 'authorize',
          id: payment.id,
          payload: {
            source: source.id
          }
        })
      } catch (error) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      }
    },
    closeDrawerReconciliation () {
      /**
       * Close and reset the reconciliation drawer data
       */
      this.drawerReconciliation = false
      this.selectedInvoices = []
      this.invoiceQuery = ''
    },
    createAdjustment () {
      /**
       * Create an adjustment for the selected transfer
       */
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.loaderAdjustment = true

      this.$store.dispatch('banks/CREATE', {
        resource: 'ach_transfers/adjustments',
        payload: {
          transfer: this.selectedTransfer.id,
          operation: this.adjustment.operation,
          amount: this.adjustment.amount,
          currency: this.adjustment.currency,
          comment: this.adjustment.comment
        }
      })
      .then(() => {
        this.dialogAdjustment = false
        this.$dialog.message.info('El ajuste ha sido creado con éxito.')

        // replace transfer object from list with adjustment data
        const payload = {
          amount: this.selectedTransfer.amount,
          balance: this.selectedTransfer.balance,
          currency: this.selectedTransfer.currency
        }

        switch (this.adjustment.operation) {
          case 'add':
            payload.amount = payload.balance += this.adjustment.amount
            break

          case 'sub':
            payload.amount = payload.balance -= this.adjustment.amount
            break

          case 'exchange':
            payload.amount = payload.balance = this.adjustment.amount
            payload.currency = this.adjustment.currency
            break

          default:
            break
        }

        this.$store.dispatch('banks/REPLACE_OBJECT', {
          resource: 'ach_transfers',
          id: this.selectedTransfer.id,
          payload: payload
        })

        // reset adjustment initial data
        this.adjustment = {
          operation: '',
          amount: null,
          currency: '',
          comment: ''
        }

        // reset validations
        this.$v.adjustment.$reset()
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderAdjustment = false
      })
    },
    destroy (instance) {
      /**
       * Destroy the transfer instance
       * @param {Object} instance Transfer object
       */
      if (instance.status === 'finalized') {
        return false
      }
      this.$dialog.warning({
        title: 'Archivar transferencia',
        text: `
          <span class="d-block my-2">Ya no podrás conciliar facturas con esta transferencia</span>
          <span class="d-block my-2">¿Estás seguro de continuar?</span>
          <span class="d-block my-2 font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Archivar',
            handle: () => {
              this.$store.dispatch('banks/DESTROY', {
                resource: 'ach_transfers',
                id: instance.id
              })
              .then(() => {
                this.dialogTransfer = false
                this.$dialog.message.info('La transferencia ha sido archivada con éxito.')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    destroyAdjustment (instance) {
      /**
       * Destroy the adjusment instance
       * @param {Object} instance Adjustment object
       */
      const adjustment = instance

      this.$dialog.warning({
        title: 'Eliminar ajuste',
        text: `
          <span class="d-block my-2">El monto de la transferencia será restaurado</span>
          <span class="d-block my-2">¿Estás seguro de continuar?</span>
          <span class="d-block my-2 font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('banks/DESTROY', {
                resource: 'ach_transfers/adjustments',
                id: instance.id
              })
              .then(() => {
                this.$dialog.message.info('El ajuste ha sido eliminado con éxito.')

                // replace transfer object from list with adjustment data
                const payload = {
                  amount: adjustment.base_amount,
                  balance: adjustment.base_amount,
                  currency: adjustment.base_currency
                }

                this.$store.dispatch('banks/REPLACE_OBJECT', {
                  resource: 'ach_transfers',
                  id: this.selectedTransfer.id,
                  payload: payload
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    disableSelection (invoice) {
      /**
       * Check if the selection must be disabled
       */
      return (!this.isInvoiceSelected(invoice) && ((this.selectedTransfer.balance - this.totalReconciliated) === 0))
    },
    getAdjustments (id) {
      /**
       * Get the adjustments related to the transfer
       * @param {Number} id Transfer id
       */
      this.$store.dispatch('banks/LIST', {
        resource: 'ach_transfers/adjustments',
        query: {
          transfer: id
        },
        loader: false
      })
    },
    getInvoices (filterTotal = false, filterTaxId = false) {
      /**
       * Get invoices based on the transfer currency and balance
       * @param {Boolean} filterTaxId Filter invoices by tax id
       */
      const query = {
        status: 'finalized',
        customer__currency: this.selectedTransfer.currency,
        ordering: '-total'
      }

      // add total filter
      if (filterTotal) {
        query.payments__balance__lte = this.selectedTransfer.balance
      }

      // add tax id filter
      if (filterTaxId && this.selectedTransfer.origin_holder_id) {
        query.customer__tax_id__contains = this.selectedTransfer.origin_holder_id.slice(0, -1)
      }

      // add invoice number filter
      if (this.invoiceQuery.length > 0) {
        query.number = this.invoiceQuery.toLowerCase()
      }

      this.$store.dispatch('invoices/LIST', {
        resource: 'invoices',
        query: query
      })
      .then((response) => {
        this.suggestedInvoices = response.data.results
      })
    },
    getInvoicesFromQuery () {
      this.getInvoices(false, (this.invoiceQuery.length === 0))
    },
    getRelatedInvoices () {
      this.$store.dispatch('invoices/LIST', {
        resource: 'invoices',
        query: {
          payments__sources__id__in: this.selectedTransfer.sources.join(',')
        }
      })
      .then((response) => {
        this.relatedInvoices = response.data.results
      })
    },
    isInvoiceSelected (invoice) {
      /**
       * Check if an invoice is selected
       * @param {Object} invoice Invoice object
       */
      return this.selectedInvoices.some(selected => selected.id === invoice.id)
    },
    openDrawerReconciliation () {
      /**
       * Open the reconciliation drawer and get related invoices
       */
      this.drawerReconciliation = true

      this.getInvoices(true, true)
    },
    openTransfer (transfer) {
      /**
       * Open the transfer dialog and get the transfer
       * data based on the transfer status
       */
      this.selectedTransfer = transfer
      this.dialogTransfer = true

      switch (transfer.status) {
        case 'finalized':
          this.getRelatedInvoices()
          break
        case 'incomplete':
          this.getRelatedInvoices()
          break
        case 'pending':
          this.relatedInvoices = []
          break
      }

      this.getAdjustments(transfer.id)
    },
    reconciliateInvoices () {
      /**
       * Reconciliate the selected invoices with the transfer
       */
      this.$dialog.warning({
        title: 'Conciliar transferencia',
        text: `
          <span class="d-block mb-4">Al confirmar:</span>
          <span class="d-block pl-6">1. El estado de las facturas seleccionadas pasará a ser <b>pagado</b></span>
          <span class="d-block pl-6">2. El estado de la transferencia pasará a ser <b>conciliado</b></span>
        `,
        actions: [
          {
            color: 'primary',
            text: 'Confirmar',
            handle: async () => {
              try {
                let remaining = this.selectedTransfer.balance

                for (const invoice of this.selectedInvoices) {
                  const amount = invoice.payments[0].balance

                  try {
                    if (remaining >= amount) {
                      await this.reconciliateInvoice(invoice, amount)
                      remaining -= amount
                    } else {
                      await this.reconciliateInvoice(invoice, remaining)
                    }
                  } catch (error) {
                    throw new Error(this.parseErrors(error.response.data))
                  }
                }

                // reset data and close drawer
                this.closeDrawerReconciliation()

                // retrieve transfer to update data
                this.retrieveTransfer(this.selectedTransfer.id)
              } catch (error) {
                this.$dialog.message.error(error)
              }
            }
          }
        ]
      })
    },
    retrieveTransfer (id) {
      /**
       * Retrieve the transfer data
       * @param {Number} id Transfer id
       */
      this.$store.dispatch('banks/RETRIEVE', {
        resource: 'ach_transfers',
        id: id
      })
      .then((response) => {
        this.selectedTransfer = Object.assign(this.selectedTransfer, response.data)
      })
      .then(() => {
        this.getRelatedInvoices()
      })
      .then(() => {
        this.getInvoices(false, true)
      })
    },
    toggleInvoiceSelection (invoice) {
      /**
       * Toggle invoice selection
       * @param {Object} invoice Invoice object
       */
      if (this.disableSelection(invoice)) {
        return
      }

      const index = this.selectedInvoices.findIndex(selected => selected.id === invoice.id)

      if (index === -1) {
        this.selectedInvoices.push(invoice)
        return
      }

      this.selectedInvoices.splice(index, 1)
    }
  },
  validations: {
    adjustment: {
      amount: {
        decimal,
        required
      },
      comment: {
        maxLength: maxLength(256),
        required
      },
      operation: {
        required
      },
      currency: {
        required: requiredIf(function () {
          return this.adjustment.operation === 'exchange'
        })
      }
    }
  }
}
</script>
<style scoped>
.v-input--checkbox {
  border: none;
  margin-top: 0;
}
.flex-shrink-0 {
  flex-shrink: 0;
  max-width: 56px;
}
</style>